import React from 'react';
import '../styles/Videos.css';

const Videos = ({tittle}) => {
    React.useEffect(()=>{
        document.getElementsByTagName('title')[0].innerHTML=`Ainsley Davis 2026 - ${tittle}`
    },[])
    // Example video data
    const videoData = [
        { id: 1, title: "March 2024 first 3’6 eq class, Maclay WEF", url: "https://www.youtube.com/embed/rZzHltzgBPQ?si=FO2mxCD3oxNXzoX3" },
        { id: 2, title: "March 2024 WEF 3’6 eq first Dover", url: "https://www.youtube.com/embed/facANd2D_rw?si=1KIWr86oztRwKsFs" },
        { id: 3, title: "2024 Champion in the 2’9 equitation", url: "https://www.youtube.com/embed/RRwSIHGB7rs?si=y3ulXdIvwt7ScXlN" },
        { id: 4, title: "July 2024 1.10 junior jumpers", url: "https://www.youtube.com/embed/StyInIYCmes?si=raXI8CLpLlHajL2K" },
        { id: 5, title: "July 2024 CPHA foundation 3’3", url: "https://www.youtube.com/embed/jiR5o4Z_8Vs?si=DSjmG_m2TtxSWOLH" },
        // Add more video data as needed
    ];

    return (
        <div className="floating-container">
            <h1 className="videos-title">{tittle}</h1>
            <div className="videos-grid">
                {videoData.map((video) => (
                    <div key={video.id} className="video-item">
                        <iframe
                            className="video-frame"
                            src={video.url}
                            title={video.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                        <p className="video-title">{video.title}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Videos;
